module.exports = __webpack_public_path__ + "img/Logo-LIB-footer.dc9d42d4.svg";